"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const ChangePassword_1 = __importDefault(require("./components/ChangePassword"));
const ContactInfoForm_1 = __importDefault(require("./components/ContactInfoForm"));
const useDonorContactInformation_1 = __importDefault(require("../../hooks/useDonorContactInformation"));
const store_1 = require("../../store/store");
const Tabs = __importStar(require("@radix-ui/react-tabs"));
const Alert_1 = __importDefault(require("../../components/Alert"));
const DonorContactInformation = () => {
    const [activeTab, setActiveTab] = (0, react_1.useState)('contact');
    const donorContactInformation = (0, useDonorContactInformation_1.default)();
    const showResetPasswordForm = (0, store_1.useAppSelector)((state) => { var _a; return (_a = state.app.appSettings) === null || _a === void 0 ? void 0 : _a.showResetPasswordForm; });
    const translations = (0, store_1.useAppSelector)((state) => state.app.translations);
    const hasWelcomeMessageInTranslations = !!(translations === null || translations === void 0 ? void 0 : translations['create-donor'].welcome);
    const hasWelcomeMessageInUrl = new URL(window.location.href).searchParams.get('m') === 'welcome';
    return ((0, jsx_runtime_1.jsxs)("div", { id: "donor-contact-information", className: "donor-contact-information", children: [hasWelcomeMessageInTranslations && hasWelcomeMessageInUrl && ((0, jsx_runtime_1.jsx)(Alert_1.default, { isOpen: true, color: "success", children: __.trans('create-donor.welcome') })), (0, jsx_runtime_1.jsxs)(Tabs.Root, { value: activeTab, onValueChange: (value) => setActiveTab(value), children: [(0, jsx_runtime_1.jsxs)(Tabs.List, { className: "tabs", children: [(0, jsx_runtime_1.jsx)(Tabs.Trigger, { value: "contact", className: (0, classnames_1.default)('tab-trigger', { active: activeTab === 'contact' }), children: __.trans('user.contact-information') }), showResetPasswordForm && ((0, jsx_runtime_1.jsx)(Tabs.Trigger, { value: "password", className: (0, classnames_1.default)('tab-trigger', { active: activeTab === 'password' }), children: __.trans('user.change-password') }))] }), (0, jsx_runtime_1.jsx)(Tabs.Content, { value: "contact", className: "tab-content", children: (0, jsx_runtime_1.jsx)(ContactInfoForm_1.default, { donorContactInformation: donorContactInformation }) }), (0, jsx_runtime_1.jsx)(Tabs.Content, { value: "password", className: "tab-content", children: (0, jsx_runtime_1.jsx)(ChangePassword_1.default, {}) })] })] }));
};
exports.default = DonorContactInformation;
